
    import './styles.scoped.css';
    export default {
  "parent": "awsui_parent_2dmmi_qu62t_5",
  "option-content": "awsui_option-content_2dmmi_qu62t_6"
};
  